module.exports = __webpack_public_path__ + "static/media/kiss-beam.d9181e67.svg";